// extracted by mini-css-extract-plugin
module.exports = {"changingPwdContent":"styles_changingPwdContent__2Mifh","formTitle":"styles_formTitle__10IMo","formBody":"styles_formBody__HfqWZ","savePwdBtn":"styles_savePwdBtn__2Lr9l"};